export default __webpack_public_path__ + "static/media/TheShowGoesOn.b9d82e95.png";